import { lazy } from 'react';
import { createPage } from '@edreamsodigeo/frontend-core';
export const page = 'canx_hub';
export const route = 'canx_hub/[bookingId]/';
export const Page = createPage(page, /*#__PURE__*/lazy(() => import('../components/CancellationPage').then(({
  CancellationPageHub
}) => ({
  default: CancellationPageHub
}))));